// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__Sty6Y","topNav":"MainLayout_topNav__vRHbM","layoutContent":"MainLayout_layoutContent__K93MX","pagesContent":"MainLayout_pagesContent__pAYC-"};